import { intlLocale } from '@refego/core/locales'
import type { Locale } from './i18n'

export function fmtMoney(minor: number | string | null | undefined, currency = 'USD', locale: Locale = 'en') {
  const v = Number(minor ?? 0) / 100
  const loc = intlLocale(locale)
  if (currency === 'USDT' || currency === 'USDC')
    return `${v.toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`
  try {
    return v.toLocaleString(loc, {
      style: 'currency',
      currency: currency.trim(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  } catch {
    return `${v.toFixed(2)} ${currency}`
  }
}

export function fmtNum(n: number | string, locale: Locale = 'en') {
  return Number(n).toLocaleString(intlLocale(locale))
}

export function fmtDate(d: string | Date | null | undefined, locale: Locale = 'en', withTime = false) {
  if (!d) return '—'
  const date = typeof d === 'string' ? new Date(d) : d
  return date.toLocaleString(
    intlLocale(locale),
    withTime ? { dateStyle: 'medium', timeStyle: 'short' } : { dateStyle: 'medium' },
  )
}

export function rewardText(
  r: { type: string; bps?: number; amountMinor?: number; event: string },
  currency: string,
  locale: Locale,
) {
  if (r.type === 'percent') return `${(r.bps! / 100).toLocaleString(intlLocale(locale))}%`
  return fmtMoney(r.amountMinor!, currency, locale)
}
